import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@ui-lib/components';
import { environment } from '../../../../environments/environment';

const DOCS_BASE_URL = environment.docsBaseUrl.replace(/\/$/, '');
const TERMS_OF_USE_PATH = '/terms-of-use';
const PARTICIPATION_AGREEMENT_PATH = '/participation-agreement';
const PRIVACY_POLICY_PATH = '/privacy-policy';
const COOKIE_POLICY_PATH = '/cookie-policy';

@Component({
  selector: 'rrp-general-footer',
  templateUrl: './general-footer.component.html',
  styleUrl: './general-footer.component.scss',
  imports: [NgOptimizedImage, RouterLink, TranslateModule, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralFooterComponent {
  public readonly termsOfUseUrl = `${DOCS_BASE_URL}${TERMS_OF_USE_PATH}`;
  public readonly participationAgreementUrl = `${DOCS_BASE_URL}${PARTICIPATION_AGREEMENT_PATH}`;
  public readonly privacyPolicyUrl = `${DOCS_BASE_URL}${PRIVACY_POLICY_PATH}`;
  public readonly cookiePolicyUrl = `${DOCS_BASE_URL}${COOKIE_POLICY_PATH}`;

  public openSupport(): void {
    window.open('https://t.me/redrock_support', '_blank', 'noopener');
  }
}
